import { FC } from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ArtifactTableProps } from './ReportDialog.props';
import { bodyCellSx, reportDialogColors as colors, headerCellSx } from './ReportDialog.styles';

const ArtifactTable: FC<ArtifactTableProps> = ({ columns, rows }) => (
  <Box sx={{ overflowX: 'auto' }}>
    <Table size="small" data-testid="daily-nav-report-artifact" sx={{ borderCollapse: 'separate', minWidth: 640 }}>
      <TableHead>
        <TableRow>
          {columns.map((column, index) => (
            <TableCell key={`${index}-${column}`} sx={headerCellSx}>
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow key={rowIndex} sx={{ bgcolor: rowIndex % 2 === 1 ? colors.zebra : 'common.white' }}>
            {columns.map((_column, columnIndex) => (
              <TableCell key={columnIndex} sx={{ ...bodyCellSx, whiteSpace: 'nowrap' }}>
                {row[columnIndex] || '—'}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

export default ArtifactTable;
